import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminLogin() {
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await axios.post(`${API}/admin/login`, { password });
      localStorage.setItem("admin_token", res.data.token);
      toast.success("Logged in");
      navigate("/admin");
    } catch {
      toast.error("Invalid password");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-6" data-testid="admin-login-page">
      <div className="w-full max-w-sm">
        <h1 className="font-heading text-3xl tracking-tight font-medium text-center mb-2">Cita Rush Admin</h1>
        <p className="text-sm text-muted-foreground text-center mb-8">Enter your admin password to continue</p>
        <form onSubmit={handleLogin} className="space-y-4">
          <Input
            type="password" value={password} onChange={(e) => setPassword(e.target.value)}
            placeholder="Admin password" className="rounded-sm" data-testid="admin-password-input"
          />
          <Button type="submit" disabled={loading} className="w-full rounded-sm" data-testid="admin-login-btn">
            {loading ? "Logging in..." : "Login"}
          </Button>
        </form>
      </div>
    </div>
  );
}
